import { DELIVERY_OPTIONS, formatMoney, GRINDS, labelOf, ROASTS, WEIGHTS } from '@c214/shared';
import type { AdminOrder } from '../../hooks/useAdminOrders';
import { OrderStatusDot } from '../orders/OrderStatusDot';
import { OrderStatusEditor } from './OrderStatusEditor';

// Один рядок замовлення в адмінці — спільний для сторінки «Замовлення» і
// розгорнутого списку замовлень користувача на сторінці «Користувачі».
// Редагувати статус можна лише на сторінці «Замовлення» (`editable`); у
// списку користувача рядок тільки для перегляду.
export function AdminOrderRow({
  order,
  editable = true,
}: {
  order: AdminOrder;
  editable?: boolean;
}) {
  return (
    <div className="px-6 py-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="font-mono text-[13px] font-bold text-ink">№{order.number}</p>
          <p className="mt-1 text-[13px] text-muted">{order.userEmail}</p>
        </div>
        <span className="text-[15px] font-bold text-ink">{formatMoney(order.total)}</span>
      </div>

      <div className="mt-2 space-y-1">
        {order.items.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: OrderItem has no own id, and the same productId can repeat with a different weight/grind, so index disambiguates
          <p key={`${item.productId}-${index}`} className="mono-label">
            {item.name} — {labelOf(WEIGHTS, item.weight)} · {labelOf(GRINDS, item.grind)}
            {item.roast ? ` · ${labelOf(ROASTS, item.roast)}` : ''} × {item.qty}
          </p>
        ))}
      </div>

      <p className="mt-2 text-[13px] text-muted">
        {labelOf(DELIVERY_OPTIONS, order.deliveryKey)}
        {order.deliveryCity ? ` · ${order.deliveryCity}` : ''}
        {order.deliveryWarehouse ? `, ${order.deliveryWarehouse}` : ''}
        {order.deliveryAddress ? `, ${order.deliveryAddress}` : ''}
      </p>
      {order.ttn && (
        <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.12em] text-muted">
          ТТН: {order.ttn}
        </p>
      )}

      <div className="mt-3">
        {editable ? <OrderStatusEditor order={order} /> : <OrderStatusDot status={order.status} />}
      </div>
    </div>
  );
}
